import TickIcon from 'components/Svg/Tick';
import styles from 'styles/modules/Tick.module.scss';

const Tick = ({ disabled, onClick, className }) => {
    return (
        <div
            className={[
                className,
                styles.input,
                disabled && styles.disabled,
            ].join(' ')}
        >
            <button onClick={!disabled ? onClick : undefined} type="button">
                <TickIcon fill={'#fff'} />
            </button>
        </div>
    );
};

export default Tick;
